<div class="main-container-mid-side text sl-round round-5 card">
  <!--  class="asd" style="max-width: 100vw"-->
  <div>
    <story-slider
      [data]="liveMatchobservable | async | removeUniquePipe : 'SportNameOriginal' : 'SportName'"
      [elementData]="storySportsData"
      [filterItem]="_liveFilterItems"
      (clickedItem)="matchFilterBySport($event)"></story-slider>
  </div>

  <ng-container [ngSwitch]="['t90'] | getProductName">
    <ng-container *ngSwitchCase="'t90'"> </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="live-standart-single-container text">
        <div class="live-standart-single-item" [ngClass]="{ active: standartSingleId == 1 }" (click)="StandartSingleChange(1)">
          {{ 'Standard' | t }}
        </div>
        <div class="live-standart-single-item" [ngClass]="{ active: standartSingleId == 2 }" (click)="StandartSingleChange(2)">
          {{ 'b3000_Single' | t }}
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div class="live-bar-container-desktop">
    <div class="live-bar-left">{{ this._DataHelper.selectedStoryItem?.sportName }} Live</div>
    <div class="live-bar-right">{{ this._DataHelper.comboSelectedOdd.OddNameLong | t }}</div>
  </div>

  <div class="odd-header">
    <div class="odd-combo-row">
      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(0)" class="combo-box">
        <select [(ngModel)]="combo1SelectedOdd" (change)="oddComboChange(combo1SelectedOdd, 0)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | t }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | t }}
            </ng-container>
          </option>
        </select>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(1)" class="combo-box">
        <select [(ngModel)]="combo2SelectedOdd" (change)="oddComboChange(combo2SelectedOdd, 1)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | t }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | t }}
            </ng-container>
          </option>
        </select>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(2)" class="combo-box">
        <select [(ngModel)]="combo3SelectedOdd" (change)="oddComboChange(combo3SelectedOdd, 2)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | t }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | t }}
            </ng-container>
          </option>
        </select>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(3)" class="combo-box">
        <select [(ngModel)]="combo4SelectedOdd" (change)="oddComboChange(combo4SelectedOdd, 3)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | t }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | t }}
            </ng-container>
          </option>
        </select>
      </div>
    </div>

    <!-- Odd Titles => Odd Buttonların içine taşındı , bu yüzden kapatıldı. 28-02-2022 -->
    <!--    <div class="odd-combo-row title-row">-->
    <!--      <div class="combo-box-title">-->
    <!--        <div class="odd-title"-->
    <!--             *ngFor="let odd of combo1SelectedOdd.OddTitles">-->
    <!--          {{odd}}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="combo-box-title">-->
    <!--        <div class="odd-title"-->
    <!--             *ngFor="let odd of combo2SelectedOdd.OddTitles">-->
    <!--          {{odd }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="combo-box-title">-->
    <!--        <div class="odd-title"-->
    <!--             *ngFor="let odd of combo3SelectedOdd.OddTitles">-->
    <!--          {{odd }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="combo-box-title">-->
    <!--        <div class="odd-title"-->
    <!--             *ngFor="let odd of combo4SelectedOdd.OddTitles">-->
    <!--          {{odd }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- Odd Titles => Odd Buttonların içine taşındı , bu yüzden kapatıldı. 28-02-2022 -->
  </div>

  <div class="odd-header mobile odd-header-mobil-margin">
    <div class="odd-filter" (click)="oddFilterToggle()">
      <image-loader-utils url="fa-slider" extraClasses="filter-icon"></image-loader-utils>
    </div>

    <div class="odd-box-row">
      <div class="odd-box" *ngFor="let odd of oddComboList" [ngClass]="{ active: combo1SelectedOdd.OddId == odd.OddId }" (click)="oddBoxClick(odd, 0)">
        {{ odd.OddName | t }}
        <ng-container *ngIf="odd.OddNameLong2 !== ''">
          {{ odd.OddNameLong2 | t }}
        </ng-container>
      </div>
    </div>
  </div>

  <div class="odd-filter-container" *ngIf="oddFilterIsActive">
    <div class="odd-filter-header">
      <div class="title">
        {{ 'filter' | t }}
      </div>
      <div (click)="oddFilterToggle()">
        <image-loader-utils url="close" extraClasses="close-icon filter-close-icon"></image-loader-utils>
      </div>
    </div>
    <div class="odd-filter-radio-box" (click)="sortByTime()">
      <div class="left">
        <div class="radio-dot" [ngClass]="{ active: this._DataHelper.liveSortbyTime }">
          <div class="dot"></div>
        </div>
      </div>
      <div class="right">{{ 'timesort' | t }}</div>
    </div>

    <div class="odd-filter-radio-box" (click)="onlyMatches()">
      <div class="left">
        <div class="radio-dot" [ngClass]="{ active: this.isHeaderShow }">
          <div class="dot"></div>
        </div>
      </div>
      <div class="right">{{ 'leagueNames' | t }}</div>
    </div>
  </div>

  <livematch-component
    [isHeaderShow]="isHeaderShow"
    (favChanged)="favsChanged()"
    [oddLiveMarketingValue]="oddLiveMarketingB3000Value"
    [isInitialized]="this.isInitialized"
    [_selectedOdds]="this._selectedOdds"
    [__ResultLiveData]="this.fullmatch"
    [isFavSection]="false"
    [sportSliderChanges]="liveFilterSelectedSportId"></livematch-component>
</div>
